export default {
    POSBank : "POSBank",
    OCBC : "OCBC",
    HSBCCORPORATE : "HSBC CORPORATE",
    HSBCPERSONAL : "HSBC PERSONAL",
    SBI : "SBI",
    STANDARDCHARTERED : "STANDARD CHARTERED",
    UOB : "UOB",
    DBS : "DBS",
    BANK_OF_CHINA : "Bank of China Limited"
}